import { render, staticRenderFns } from "./CompetitionsReportCard.vue?vue&type=template&id=27d088f9"
import script from "./CompetitionsReportCard.vue?vue&type=script&lang=ts"
export * from "./CompetitionsReportCard.vue?vue&type=script&lang=ts"
import style0 from "./CompetitionsReportCard.vue?vue&type=style&index=0&id=27d088f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports